import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/brand/brand/apps/docs/node_modules/@primer/gatsby-theme-doctocat/src/components/layout.js";
import { Button, Stack } from '@primer/react-brand';
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const Note = makeShortcode("Note");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <Note mdxType="Note">This information is only relevant to GitHub staff.</Note>
    <h2>{`Using Storybook`}</h2>
    <p>{`Additional examples for Primer Brand component layouts and recipes are avaialble in our private Storybook instance.`}</p>
    <p>{`Please note that access to this instance is restricted to signed-in collaborators of the `}<inlineCode parentName="p">{`primer/primer-brand-storybook`}</inlineCode>{` repository. If you are a GitHub staff member and would like access to Storybook, please request it in the `}<a parentName="p" {...{
        "href": "https://github.slack.com/archives/C03FY9G00NS"
      }}>{`#primer-brand`}</a>{` Slack channel.`}</p>
    <p>
  <Stack padding="none" direction="horizontal" mdxType="Stack">
    <Button as="a" variant="primary" href="https://gh.io/primer-brand-storybook" mdxType="Button">
      Go to Storybook
    </Button>
    <Button as="a" href="https://github.slack.com/archives/C03FY9G00NS" mdxType="Button">
      Request access
    </Button>
  </Stack>
    </p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      